import { resolveResponsiveProp } from '../../library/props/responsiveProp';
import * as styles from './useNegativeMargin.css';
export const useNegativeMarginLeft = space => {
  return resolveResponsiveProp(space, styles.negativeMarginLeftBreakpointsMap);
};
export const useNegativeMarginTop = space => {
  return resolveResponsiveProp(space, styles.negativeMarginTopBreakpointsMap);
};
//# sourceMappingURL=useNegativeMargin.js.map